export const ENDPOINTS = {
  MASTER: 'master',
  AREAS: 'areas',
  DEPARTMENTS: 'departments',
  ASSET_CATEGORIES: 'asset-categories',
  UNITS: 'units',
  SUBMIT_DESTINATIONS: 'submit-destinations',
  CAUSES: 'causes',
}
